import styled from '@emotion/styled';

export const ModalDescription = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: #9e9e9e;
  margin: 0 0 16px 0;
  line-height: 1.5;
`;

export const SlideContent = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 24px;
`;

export const SelectGroup = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  height: 66px;
  align-items: center;
`;

export const SelectWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const Label = styled.label`
  font-size: 16px;
  font-weight: 700;
  color: #444444;
  display: block;
  line-height: 1.5;
`;

export const SelectContainer = styled.div`
  width: 100%;

  .react-select__control {
    border: 2px solid #e0e0e0;
    border-radius: 4px;
    min-height: 40px;
    font-family: 'Nunito Sans', sans-serif;
    box-shadow: none;
    cursor: pointer;
    background: #ffffff;

    &:hover {
      border-color: #b0b0b0;
    }
  }

  .react-select__control--is-focused {
    border-color: #e0e0e0;
    box-shadow: none;
  }

  .react-select__value-container {
    padding: 8px 16px;
  }

  .react-select__single-value {
    font-size: 16px;
    font-weight: 400;
    color: #444444;
    line-height: 1.5;
  }

  .react-select__placeholder {
    font-size: 16px;
    color: #9e9e9e;
  }

  .react-select__indicator-separator {
    display: none;
  }

  .react-select__dropdown-indicator {
    color: #9e9e9e;
    padding: 8px;

    &:hover {
      color: #444444;
    }
  }

  .react-select__menu {
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    margin-top: 4px;
    z-index: 9999;
  }

  .react-select__menu-list {
    padding: 0;
    max-height: 300px;
  }

  .react-select__option {
    font-size: 16px;
    font-weight: 400;
    padding: 10px 16px;
    cursor: pointer;
    font-family: 'Nunito Sans', sans-serif;
  }

  .react-select__option--is-focused {
    background-color: #f5f5f5;
  }

  .react-select__option--is-selected {
    background-color: #444444;
    color: #ffffff;
    font-weight: 600;

    &:hover {
      background-color: #444444;
    }
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 24px;
`;

export const PrimaryButton = styled.button`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.48px;
  text-transform: uppercase;
  width: 100%;
  height: 35px;
  background: #444444;
  color: white;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  user-select: none;
  border: 1px solid #444444;
  margin-bottom: 8px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const SecondaryButton = styled.button`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.48px;
  text-transform: uppercase;
  width: 100%;
  height: 35px;
  background: white;
  color: #444444;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  user-select: none;
  border: 1px solid #444444;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ErrorText = styled.p`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 14px;
  color: #d32f2f;
  margin: 8px 0 0 0;
  text-align: center;
`;
